"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMetasiteId = exports.createDataForQuestionOpen = void 0;
function buildPayload(options, params) {
    var _a = params.config, FEEDBACK_SERVICE_BASE_URL = _a.FEEDBACK_SERVICE_BASE_URL, EXPOSURE_SERVICE_BASE_URL = _a.EXPOSURE_SERVICE_BASE_URL, _b = params.options, locale = _b.locale, siteToken = _b.siteToken, metasiteId = _b.metasiteId, origin = _b.origin, sessionId = params.sessionId, categoryId = params.categoryId;
    var customContext = options.customContext, noDontShowAgain = options.noDontShowAgain, questionId = options.questionId, triggerEvent = options.triggerEvent, feedbackModel = options.feedbackModel, thankYouPage = options.thankYouPage, initiator = options.initiator, documentationLink = options.documentationLink;
    return {
        windowConfig: {
            locale: locale,
            disableDontShowAgain: noDontShowAgain,
            documentationLink: documentationLink,
        },
        flowConfig: {
            thankYouPage: thankYouPage,
        },
        questionContext: {
            categoryId: categoryId,
            customContext: customContext,
            initiator: initiator,
            metasiteId: metasiteId,
            origin: origin,
            questionId: questionId,
            sessionId: sessionId,
            siteToken: siteToken,
            triggerEvent: triggerEvent,
        },
        questionModel: feedbackModel,
        topologyConfig: {
            exposureServiceBaseUrl: EXPOSURE_SERVICE_BASE_URL,
            feedbackServiceBaseUrl: FEEDBACK_SERVICE_BASE_URL,
        },
    };
}
function createDataForQuestionOpen(showOptions, params) {
    var _a = params.startOpeningTime, startOpeningTime = _a === void 0 ? new Date().getTime() : _a, experiments = params.experiments;
    return {
        meta: {
            startOpeningTime: startOpeningTime,
            experiments: experiments,
        },
        payload: buildPayload(showOptions, params),
    };
}
exports.createDataForQuestionOpen = createDataForQuestionOpen;
function parseMetasiteId(metasiteId) {
    return metasiteId.replace(/^_template_/, '');
}
exports.parseMetasiteId = parseMetasiteId;
//# sourceMappingURL=opener.utils.js.map